import { FC } from 'react';
import { Box, Text, Skeleton } from '@chakra-ui/react';
import { TokensCard } from '../../assets/TokensCard';
import { formatNumber, pluralize } from '../../helpers';
export interface CbTokensAvailableCardProps {
  fontSize?: string;
  isPending: boolean;
  tokenBalance: number;
}
export const CbTokensAvailableCard: FC<CbTokensAvailableCardProps> = ({
  fontSize,
  isPending,
  tokenBalance
}) => {
  return <Box position="relative" data-sentry-element="Box" data-sentry-component="CbTokensAvailableCard" data-sentry-source-file="CbTokensAvailableCard.tsx">
      <TokensCard data-sentry-element="TokensCard" data-sentry-source-file="CbTokensAvailableCard.tsx" />
      <Box position="absolute" top="10%" right="5%" data-sentry-element="Box" data-sentry-source-file="CbTokensAvailableCard.tsx">
        {isPending ? <>
            <Skeleton data-testid="skeleton" height={22} width={164} marginTop="2px" marginBottom={2} />
            <Skeleton height={22} width={110} marginLeft="auto" />
          </> : <Text color="white" fontSize={fontSize ? fontSize : {
        base: 'md',
        sm: '2xl'
      }} fontFamily="codenext" lineHeight="1.2" textAlign="right">
            <Box as="span">{formatNumber(tokenBalance)}</Box>
            {` ${pluralize(tokenBalance, 'Token')}`}
            <br />
            {'Available'}
          </Text>}
      </Box>
    </Box>;
};